import axios from 'axios';
import { getAPIUrl } from 'services/backend/baseAPI';

// New type matching updated API response
export interface SurveyEventLogEntry {
  id: number;
  createdAt: string;
  incidenceRate: string;
  isUserSystem: boolean;
  questionCount: number;
  paymentAmount: string;
  paymentType: string;
  respondentCount: number;
  surveyId: number;
  user: {
    id: number;
    email: string;
    fullName: string;
  };
  status: {
    id: number;
    name: string;
  };
}

// Transformed type for component display
export interface DisplayEventLogEntry {
  id: number; // Unique ID from API
  createdAt: string;
  statusName: string; // status.name
  userFullName: string;
  userEmail: string;
  userId: number;
  isUserSystem: boolean;
  respondentCount: number;
  incidenceRate: string;
  questionCount: number;
  paymentAmount: string;
  paymentType: string;
  surveyId: number;
}

export const FETCH_SURVEY_EVENT_LOG = ({ surveyId }: { surveyId: number }) => ({
  path: `/surveys/${surveyId}/eventlog`,
  version: 'v2' as const,
});

// Updated service function
export async function fetchSurveyEventLog({
  surveyId,
}: {
  surveyId: number;
}): Promise<SurveyEventLogEntry[]> {
  const response = await axios.get(
    getAPIUrl(FETCH_SURVEY_EVENT_LOG({ surveyId })),
  );
  return response.data;
}

export const FETCH_ORGANIZATION_EVENT_LOG = ({
  organizationId,
}: {
  organizationId: number;
}) => ({
  path: `/organizations/${organizationId}/eventlog`,
  version: 'v2' as const,
});

export async function fetchOrganizationEventLog({
  organizationId,
}: {
  organizationId: number;
}): Promise<SurveyEventLogEntry[]> {
  const response = await axios.get(
    getAPIUrl(FETCH_ORGANIZATION_EVENT_LOG({ organizationId })),
  );
  return response.data;
}

// Data transformation function
export function transformEventLogEntry(
  entry: SurveyEventLogEntry,
): DisplayEventLogEntry {
  return {
    id: entry.id,
    createdAt: entry.createdAt,
    statusName: entry.status.name,
    userFullName: entry.isUserSystem ? 'System' : entry.user.fullName,
    userEmail: entry.user.email ?? '',
    userId: entry.user.id ?? 0,
    isUserSystem: entry.isUserSystem,
    respondentCount: entry.respondentCount,
    incidenceRate: entry.incidenceRate,
    questionCount: entry.questionCount,
    paymentAmount: entry.paymentAmount ?? '',
    paymentType: entry.paymentType ?? '',
    surveyId: entry.surveyId,
  };
}
